module.exports = __webpack_public_path__ + "static/media/backyard_image.7f2d46d4.jpg";